import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import classes from './LogPostItem.module.css';
import { categoryImages, formatSimpleDate, getAuthorName, getRgbFromColorName, utcToLocalDateTime } from 'shared/utility';

const logPostItem = (props) => {
  let categoryImage = null;
  const containerClasses = [classes.LogPost];
  if (props.type) containerClasses.push(classes[props.type]);
  if (props.categoryImage) {
    categoryImage = categoryImages.find((category) => category.name === props.categoryImage);
  }
  const dateModified = props.post && props.post.DatePostUpdated ? formatSimpleDate(utcToLocalDateTime(props.post.DatePostUpdated).toString()) : '';
  const dateAdded = props.post && props.post.DateCreated ? formatSimpleDate(utcToLocalDateTime(props.post.DateCreated).toString()) : '';
  const author = getAuthorName(props.post.NickName, props.post.FirstName);
  const footerDate =
    props.sortBy === 'DateStart' ? null : (
      <p className={classes.FooterDate}>{props.sortBy === 'DatePostUpdated' ? ` Modified ${dateModified}` : `Added ${dateAdded}`}</p>
    );

  return (
    <div>
      <div className={containerClasses.join(' ')} onClick={() => props.handleSelect(props.post.PostId, props.page)}>
        {props.isUnread ? <FontAwesomeIcon icon="circle" className={classes.UnreadIcon} /> : null}
        {props.postImageUrl ? (
          <div className={classes.LogPostImageContainer}>
            <img src={props.postImageUrl} alt={props.post.Name} />
          </div>
        ) : null}
        <div className={classes.TitleContainer}>
          {categoryImage ? <categoryImage.image /> : null}
          <h3 name="post-title" className={classes.PostTitle}>
            {props.post.Name}
          </h3>
        </div>
        <div className={classes.PostSubInfo}>
          <p className={classes.PostDate}>{props.date}</p>
          <div className={classes.Footer}>
            <p className={classes.PostAuthor} style={{ color: props.post.Color ? getRgbFromColorName(props.post.Color) : 'rgb(108, 162, 183)' }}>
              {author}
            </p>
            {footerDate}
          </div>
        </div>
      </div>
    </div>
  );
};

export default logPostItem;
